import IconButton, { IconButtonProps } from "@mui/material/IconButton";
import { Iconify } from "@onair/minimal-ui/iconify";
import { cn } from "@onair/utils/cn";
import React from "react";

interface PropTypes extends IconButtonProps {
	onClick: () => void;
}

const CloseCircleButton: React.FC<PropTypes> = ({ onClick, className }) => {
	return (
		<IconButton
			size="small"
			color="inherit"
			onClick={onClick}
			className={cn(
				"border w-6 h-6 border-solid border-white !bg-black/80 !hover:bg-black",
				className || "",
			)}
		>
			<Iconify width={16} className="text-white" icon="mingcute:close-line" />
		</IconButton>
	);
};

export default CloseCircleButton;
